module.exports = __webpack_public_path__ + "static/media/logo-navy.4971c65b.png";